import { render, staticRenderFns } from "./PlacesPage.vue?vue&type=template&id=4fd6a766&scoped=true&"
import script from "./PlacesPage.vue?vue&type=script&lang=js&"
export * from "./PlacesPage.vue?vue&type=script&lang=js&"
import style0 from "./PlacesPage.vue?vue&type=style&index=0&id=4fd6a766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd6a766",
  null
  
)

export default component.exports